import { c as _c } from "react/compiler-runtime";
import SkeletonLoader from "./SkeletonLoader";
interface ISkeletonCardProps {
  className?: string;
}
const SkeletonCard = props => {
  const $ = _c(3);
  const {
    className: t0
  } = props;
  const className = t0 === undefined ? "" : t0;
  const t1 = `h-full w-full p-2 ${className}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-full rounded-lg p-4 shadow-[0_6px_14px_rgba(0,0,0,0.08)]"><SkeletonLoader /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <div className={t1}>{t2}</div>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default SkeletonCard;